export enum Routes {
  ANY = '**',
  RACINE = '',
  CREDIT = 'credit',
  COORDONNEES = 'coordonnees',
  MODIFIER = 'modifier',
  VALIDATION = 'validation',
  ERREUR = 'erreur',
  CONFIRMATION = 'confirmation',
}
